import { render, staticRenderFns } from "./ArticleManagementModal.vue?vue&type=template&id=6c4a86ce&"
import script from "./ArticleManagementModal.vue?vue&type=script&lang=js&"
export * from "./ArticleManagementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports